import { Alert } from "@mui/material";
import { isEmpty, isNil } from "lodash";

const ErrorMessageHelper = ({ error }) => {
  try {
    if (Array.isArray(error)) {
      return error.map((err, index) => <div key={index}>{err}</div>);
    }
    if (typeof error === "object" && error !== null) {
      return Object.values(error).map((err, index) => {
        // If the error value is an array, display all items
        if (Array.isArray(err)) {
          return err.map((item, itemIndex) => (
            <div key={`${index}-${itemIndex}`}>{item}</div>
          ));
        }
        // If it's an object, stringify it
        if (typeof err === "object") {
          return <div key={index}>{JSON.stringify(err)}</div>;
        }
        // Otherwise display as is
        return <div key={index}>{err}</div>;
      });
    }
    return <div>{error}</div>;
  } catch (e) {
    return <div>Something went wrong. Please try again later.</div>;
  }
};

export const MutationError = ({ error, sx }) => {
  if (!error) return null;

  // Don't show error if message or errors is an empty string
  if (error?.message === "" || error?.errors === "") return null;

  // Handle CORS error - check multiple possible error formats
  if (
    error?.message?.includes("CORS") ||
    error?.message?.includes("Network Error") ||
    error?.toString()?.includes("CORS") ||
    error?.toString()?.includes("Network Error") ||
    error?.name === "NetworkError"
  ) {
    return (
      <Alert severity="error" sx={sx}>
        Unable to connect to the server. Please check your internet connection
        or contact support if the problem persists.
      </Alert>
    );
  }

  // Handle Request Entity Too Large error - check multiple possible error formats
  if (
    error?.message?.includes("413") ||
    error?.message?.includes("Request Entity Too Large") ||
    error?.toString()?.includes("413") ||
    error?.toString()?.includes("Request Entity Too Large") ||
    error?.status === 413
  ) {
    return (
      <Alert severity="error" sx={sx}>
        The data being sent is too large. Please try again.
      </Alert>
    );
  }

  // Handle case where error is a string
  if (typeof error === "string") {
    return (
      <Alert severity="error" sx={sx}>
        {error}
      </Alert>
    );
  }

  // Handle case where error.errors is a string
  if (typeof error?.errors === "string") {
    return (
      <Alert severity="error" sx={sx}>
        {error.errors}
      </Alert>
    );
  }

  // Handle case where error.errors is an object or array
  if (error?.errors && !isNil(error.errors) && !isEmpty(error.errors)) {
    return (
      <Alert severity="error" sx={sx}>
        <ErrorMessageHelper error={error.errors} />
      </Alert>
    );
  }

  // Handle case where error.message exists
  if (error?.message) {
    return (
      <Alert severity="error" sx={sx}>
        {error.message}
      </Alert>
    );
  }

  // Fallback for any other error format
  return (
    <Alert severity="error" sx={sx}>
      An error occurred. Please try again or contact support if the problem
      persists.
    </Alert>
  );
};
